import React, { useEffect, useState } from "react";
import { FaEdit, FaLock } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Badge, Card, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyKitPreparation from "./UpdateStudyKitPreparation";
import AddNewStudyKitPreparation from "./AddNewStudyKitPreparation";
import DeletedStudyKitPreparation from "./DeletedStudyKitPreparation";
import KitPreparationActivities from "./KitPreparationActivities";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import Moment from "react-moment";
import { studyTreatmentManagementServices } from "../../../../APIServices/CTMS/studyTreatmentManagementServices";
import { eiwrsKitTypeServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitTypeServices";
import ReleaseKitPreparation from "./ReleaseKitPreparation";
import RunQCKitPreparation from "./RunQCKitPreparation";
import QuarantinedKitPreparation from "./QuarantinedKitPreparation";
import { handleResponse } from "../../../../APIHelpers/Responses";
import { eiwrsKitMetadataServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";

const StudyKitInventoryDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [kitData, setKitData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [kitList, setKitList] = useState([]);
  const [kitCount, setKitCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState("");
  const [actionLoader, setActionLoader] = useState("");
  const [activeTab, setActiveTab] = useState("activities");
  const [kitId, setKitId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [kitActivity, setKitActivity] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [kitActivityCount, setKitActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(kitCount / itemsPerPage);

  const getStudyKitInventory = async (e) => {
    setLoading(true);
    let data = await eiwrsKitPreparationServices.getStudyKitInventory(
      studyId,
      "active",
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setKitList(data?.data || []);
    setKitCount(data?.count || 0);
    setLoading(false);
  };

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    setColumns(data?.data || []);
  };

  const downloadReportStudyKitInventory = async (type) => {
    if (type) {
      setLoader(type);
      let data = await eiwrsKitPreparationServices.getStudyKitInventory(
        studyId,
        "active",
        StudyMode,
      );
      if (type === "csv") {
        downloadCSV(data?.data || [])
      }
      if (type === "excel") {
        downloadExcel(data?.data || [])
      }
      setLoader("");
    }
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyKitPreparation",
      studyId,
      kitData?.kitId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setKitActivity(data?.data || []);
    setKitActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const downloadCSV = (data) => {
    if (data.length === 0) {
      handleResponse({
        statusCode: 400,
        customMessage: "Kit not found"
      })
    }
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Kit Number",
      "Kit Type",
      "Depot",
      "Batch Number",
      "Treatment",
      "Expiry DT",

      ...(columns || []).map(
        (item) => item?.columnLabel || item?.columnName
      ),

      "Status",
    ];

    const rows = data.map((kitData, index) => {
      const dynamicValues = (columns || []).map((item) => {
        const columnData = (kitData?.columns || []).find(
          (ele) => ele?.columnName === item?.columnName
        );

        return columnData?.columnValue ?? "_";
      });

      return [
        index + 1,
        kitData?.kitNumber,
        kitData?.kitType,
        kitData?.depot,
        kitData?.batchNumber,
        (eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ? kitData?.treatment || "_" : "Blinded",
        kitData?.expiryDate,
        ...dynamicValues,
        kitData?.quarantined
          ? "quarantined"
          : kitData?.status === "inPreparation"
            ? "In Preparation"
            : kitData?.status === "pendingQC"
              ? "Pending QC"
              : kitData?.status === "failedQC"
                ? "Failed QC"
                : kitData?.status === "available"
                  ? "Available at Depot"
                  : kitData?.status === "allocated"
                    ? "Allocated at Site"
                    : kitData?.status === "passedQC"
                      ? "Passed QC"
                      : kitData?.status,
      ];
    });
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Kit_Inventory.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = (data) => {
    if (data.length === 0) {
      handleResponse({
        statusCode: 400,
        customMessage: "Kit not found"
      })
    }
    if (!data || !data.length) return;
    const excelData = data.map((kitData, index) => {
      const dynamicColumns = (columns || []).reduce((acc, item) => {
        const columnData = (kitData?.columns || []).find(
          (ele) => ele?.columnName === item?.columnName
        );

        acc[item?.columnLabel || item?.columnName] =
          columnData?.columnValue ?? "_";

        return acc;
      }, {});

      return {
        "Sr.": index + 1,
        "Kit Number": kitData?.kitNumber,
        "Kit Type": kitData?.kitType,
        "Depot": kitData?.depot,
        "Batch Number": kitData?.batchNumber,
        "Treatment": (eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ? kitData?.treatment || "_" : "Blinded",
        "Expiry DT": kitData?.expiryDate,

        ...dynamicColumns,

        "Status": kitData?.quarantined
          ? "quarantined"
          : kitData?.status === "inPreparation"
            ? "In Preparation"
            : kitData?.status === "pendingQC"
              ? "Pending QC"
              : kitData?.status === "failedQC"
                ? "Failed QC"
                : kitData?.status === "available"
                  ? "Available at Depot"
                  : kitData?.status === "allocated"
                    ? "Allocated at Site"
                    : kitData?.status === "passedQC"
                      ? "Passed QC"
                      : kitData?.status,
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Kit Inventory");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "kit_inventory.xlsx");
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [kitData]);

  useEffect(() => {
    getEIWRSKitMetadataData();
  }, []);

  useEffect(() => {
    getStudyKitInventory();
  }, [searchData, pageNumber, itemsPerPage]);

  const updateStudyKitPreparation = async (id, retentionKit) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Retention Kit in this Study!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.retentionKit = retentionKit;
        userData.mode = StudyMode;
        let data = await eiwrsKitPreparationServices.updateStudyKitPreparation(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyKitInventory();
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {kitCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <button
            onClick={() => downloadReportStudyKitInventory("excel")}
            disabled={loader}
            className="updateProfile"
            style={{ fontSize: 12 }}
          >
            {loader === "excel" ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Downloading...
              </div>
            ) : (
              "Download Excel"
            )}
          </button>
          <button
            disabled={loader}
            onClick={() => downloadReportStudyKitInventory("csv")}
            className="updateProfile"
            style={{ fontSize: 12 }}
          >
            {loader === "csv" ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Downloading...
              </div>
            ) : (
              "Download CSV"
            )}
          </button>
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={kitId ? "40%" : "100%"}
      >
        <>
          {loading ? (
            <PageLoader />
          ) : kitCount === 0 ? (
            <NoDataFoundTable MSG={"Study Kit not found!"} />
          ) : kitList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Kit not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    {columns?.filter(column => column?.isUnique === "yes")?.map((item, index) => (
                      <th onMouseDown={(e) => onMouseDown(e, 1 + index)}>
                        {item?.columnLabel}
                      </th>
                    ))}
                    <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 1)}>
                      Kit Number
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 2)}>
                      Kit Type
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 3)}>
                      Depot
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 4)}>
                      Batch Number
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 5)}>
                      Treatment
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 6)}>
                      Expiry DT
                    </th>
                    {columns?.filter(column => column?.isUnique === "no")?.map((item, index) => (
                      <th onMouseDown={(e) => onMouseDown(e, columns?.filter(column => column?.isUnique === "yes")?.length + 7 + index)}>
                        {item?.columnLabel}
                      </th>
                    ))}
                    <th onMouseDown={(e) => onMouseDown(e, columns?.length + 7)}>
                      Retention Kit
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, columns?.length + 8)}>
                      Status
                    </th>
                    <th
                      className="text-center"
                      onMouseDown={(e) => onMouseDown(e, columns?.length + 9)}
                      style={{ width: 60 }}
                    >
                      View
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kitList?.map((kitData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${kitData?.type !== "predefine" && "CP"} ${kitId === kitData?._id ? "highlighted" : ""
                        }`}
                    >
                      <td
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      {columns?.filter(column => column?.isUnique === "yes")?.map(item => {
                        const columnData = (kitData?.columns || [])?.find(
                          (ele) => ele?.columnName === item?.columnName
                        );
                        return (
                          <td
                            key={item?.columnId || item?.columnName}
                            onClick={() => {
                              setKitData(kitData);
                              setKitId(kitData?._id);
                            }}
                          >
                            {columnData?.columnValue || ""}
                          </td>
                        );
                      })}
                      <td
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {kitData?.kitNumber}
                      </td>
                      <td
                        className="text-capitalize"
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {kitData?.kitType}
                      </td>
                      <td
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {kitData?.depot}
                      </td>
                      <td
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {kitData?.batchNumber}
                      </td>
                      <td
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {(eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                          kitData?.treatment
                          :
                          <Badge style={{ width: 50 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                        }
                      </td>
                      <td
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {kitData.expiryDate}
                      </td>
                      {columns?.filter(column => column?.isUnique === "no")?.map(item => {
                        const columnData = (kitData?.columns || [])?.find(
                          (ele) => ele?.columnName === item?.columnName
                        );
                        return (
                          <td
                            key={item?.columnId || item?.columnName}
                            onClick={() => {
                              setKitData(kitData);
                              setKitId(kitData?._id);
                            }}
                          >
                            {columnData?.columnValue || ""}
                          </td>
                        );
                      })}
                      <td
                        className={`fw-bold text-capitalize ${kitData?.quarantined ? "text-danger" : kitData?.status === "inPreparation" ? "text-warning" : (kitData?.status === "available" || kitData?.status === "allocated" || kitData?.status === "released" || kitData?.status === "passedQC" || kitData?.status === "dispensed") ? "text-success" : kitData?.status === "pendingQC" ? "text-secondary" : (kitData?.status === "expired" || kitData?.status === "failedQC" || kitData?.status === "rework") ? "text-danger" : "text-primary"}`}
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        <Form.Select
                          onChange={(e) => updateStudyKitPreparation(kitData?._id, e.target.value)}
                          className="br3"
                          size="sm"
                          style={{ width: 180 }}
                          value={kitData?.retentionKit}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>
                      </td>
                      <td
                        className={`fw-bold text-capitalize ${kitData?.quarantined ? "text-danger" : kitData?.status === "inPreparation" ? "text-warning" : (kitData?.status === "available" || kitData?.status === "allocated" || kitData?.status === "released" || kitData?.status === "passedQC" || kitData?.status === "dispensed") ? "text-success" : kitData?.status === "pendingQC" ? "text-secondary" : (kitData?.status === "expired" || kitData?.status === "failedQC" || kitData?.status === "rework") ? "text-danger" : "text-primary"}`}
                        onClick={() => {
                          setKitData(kitData);
                          setKitId(kitData?._id);
                        }}
                      >
                        {kitData?.quarantined ? "quarantined" : kitData?.status === "inPreparation" ? "In Preparation" : kitData?.status === "pendingQC" ? "Pending QC" : kitData?.status === "failedQC" ? "Failed QC" : kitData?.status === "available" ? "Available at Depot" : kitData?.status === "allocated" ? "Allocated at Site" : kitData?.status === "passedQC" ? "Passed QC" : kitData?.status}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${kitData?.kitNumber}`}
                      >
                        <button
                          onClick={(e) => {
                            setKitData(kitData);
                            setToggle();
                            e.stopPropagation();
                          }}
                          className={`updateProfile text-center`}
                          style={{ padding: "1px 10px" }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={kitCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </>
        {kitId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setKitId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <KitPreparationActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                kitActivity={kitActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                kitData={kitData}
                kitActivityCount={kitActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <QuarantinedKitPreparation
        Show={!toggle}
        Hide={setToggle}
        kitData={kitData}
        setKitId={setKitId}
        getStudyKitInventory={getStudyKitInventory}
        columns={columns}
        Title={"View kit Details"}
        eiwrsPermission={eiwrsPermission}
      />
    </>
  );
};

export default StudyKitInventoryDataList;
